import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, VERSION, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';

type AssetEntry = {
  kind: 'script' | 'style';
  fileName: string;
  fullUrl: string;
};

const APP_VERSION = '1.0.81';

@Component({
  selector: 'app-build-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './build-info.component.html',
  styleUrl: './build-info.component.scss',
})
export class BuildInfoComponent {
  private readonly document = inject(DOCUMENT);

  readonly appVersion = APP_VERSION;
  readonly angularVersion = VERSION.full;
  readonly openedAt = new Date().toISOString();
  readonly environmentName = environment.production ? 'production' : 'non-production';
  readonly currentUrl = this.document.location?.href ?? '';
  readonly loadedAssets = this.collectAssets();

  private collectAssets(): AssetEntry[] {
    const scriptAssets = Array.from(this.document.querySelectorAll('script[src]'))
      .map(script => this.toAsset('script', script.getAttribute('src')));

    const styleAssets = Array.from(this.document.querySelectorAll('link[rel="stylesheet"][href]'))
      .map(link => this.toAsset('style', link.getAttribute('href')));

    return [...scriptAssets, ...styleAssets].filter((entry): entry is AssetEntry => entry !== null);
  }

  private toAsset(kind: 'script' | 'style', rawUrl: string | null): AssetEntry | null {
    if (!rawUrl) {
      return null;
    }

    const absoluteUrl = new URL(rawUrl, this.document.baseURI).href;
    const pathname = new URL(absoluteUrl).pathname;
    const fileName = pathname.split('/').filter(Boolean).pop() ?? pathname;

    return {
      kind,
      fileName,
      fullUrl: absoluteUrl,
    };
  }
}